import React, { useState } from 'react';
import { captureException } from '@sentry/nextjs';
import { useSkipReflectionMutation } from 'types/generated/client';
import { useModal } from 'hooks/useModal';
import SkipReflectionModal from './SkipReflectionModal';

type PlayerType = {
  playerId: string;
  playerName: string;
  lessonId: string;
};

const useSkipReflection = ({ refetchQueries }: { refetchQueries: string[] }) => {
  const { isOpen, openModal, closeModal } = useModal();

  const [skipReflection, { loading: skipReflectionLoading }] = useSkipReflectionMutation();

  const [selectedPlayerForSkipReflection, setSelectedPlayerForSkipReflection] =
    useState<PlayerType | null>(null);

  const promptSkipReflection = ({ playerId, playerName, lessonId }: PlayerType) => {
    setSelectedPlayerForSkipReflection({ playerId, playerName, lessonId });
    openModal();
  };

  const handleSkipReflection = async () => {
    try {
      if (!selectedPlayerForSkipReflection) return;
      await skipReflection({
        variables: {
          userId: selectedPlayerForSkipReflection.playerId,
          lessonId: selectedPlayerForSkipReflection.lessonId,
        },
        refetchQueries,
      });
      setSelectedPlayerForSkipReflection(null);
      closeModal();
    } catch (error) {
      captureException(error);
    }
  };

  return {
    SkipReflectionModalJsx: (
      <SkipReflectionModal
        isOpen={isOpen}
        handleClose={closeModal}
        handleSkipReflection={handleSkipReflection}
        loading={skipReflectionLoading}
        playerName={selectedPlayerForSkipReflection?.playerName}
      />
    ),
    promptSkipReflection,
  };
};

export default useSkipReflection;
